import { axiosInstance } from "./axios";

export const GetTotalCountRemainingSessions = async() => {
  return await axiosInstance
    .get("/corporations/remainingSessions")
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
